export enum MoedaAjuste {
  BRL = 1,
  USD = 2,
  EUR = 3,
  CLP = 4,
  PEN = 5,
  COP = 6,
  MXN = 7,
  CAD = 8,
  JPY = 9,
  GBP = 10,
  DKK = 11,
  NOK = 12,
  SEK = 13,
  PYG = 14,
}

export const MOEDA_AJUSTE_LABEL: Record<MoedaAjuste, string> = {
  [MoedaAjuste.BRL]: 'BRL',
  [MoedaAjuste.USD]: 'USD',
  [MoedaAjuste.EUR]: 'EUR',
  [MoedaAjuste.CLP]: 'CLP',
  [MoedaAjuste.PEN]: 'PEN',
  [MoedaAjuste.COP]: 'COP',
  [MoedaAjuste.MXN]: 'MXN',
  [MoedaAjuste.CAD]: 'CAD',
  [MoedaAjuste.JPY]: 'JPY',
  [MoedaAjuste.GBP]: 'GBP',
  [MoedaAjuste.DKK]: 'DKK',
  [MoedaAjuste.NOK]: 'NOK',
  [MoedaAjuste.SEK]: 'SEK',
  [MoedaAjuste.PYG]: 'PYG',
};

export const MOEDA_AJUSTE_ORDER: MoedaAjuste[] = [
  MoedaAjuste.BRL,
  MoedaAjuste.USD,
  MoedaAjuste.EUR,
  MoedaAjuste.GBP,
  MoedaAjuste.JPY,
  MoedaAjuste.CAD,
  MoedaAjuste.MXN,
  MoedaAjuste.CLP,
  MoedaAjuste.PEN,
  MoedaAjuste.COP,
  MoedaAjuste.DKK,
  MoedaAjuste.NOK,
  MoedaAjuste.SEK,
  MoedaAjuste.PYG,
];

export interface AjusteAntecipacao {
  id: string;
  usuarioId: string;
  moeda: MoedaAjuste;
  moedaSigla: string;
  /** Saldo pendente atual (decrementado por vendas). */
  valor: number;
  /** Baseline do último upsert do admin. */
  valorInicial: number;
  /** valorInicial - valor (já abatido por vendas, clamp >= 0). */
  valorPago: number;
  /** (valorPago / valorInicial) * 100 (clamp 0..100). 0 quando valorInicial = 0. */
  percentualQuitado: number;
  motivo: string | null;
  createdById: string | null;
  updatedById: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface UpsertAjusteAntecipacaoPayload {
  valor: number;
  motivo?: string;
}
